import React from 'react';
import { StudentNavbar, Quiz } from '../../../../components';
import { getSubjectMeta } from '../../../../constants/subjectMeta';

const MathematicsQuizzes = () => {
  const subjectMeta = getSubjectMeta('bgcse', 'mathematics');

  if (!subjectMeta) return null;

  return (
    <div>
      <StudentNavbar />
      <div className="flex w-full">
        <div className="w-full h-screen">
          <Quiz img={subjectMeta.image} subjectName={subjectMeta.label} />
        </div>
      </div>
    </div>
  );
};

export default MathematicsQuizzes;